import { pb } from "@/utils/PocketBaseAdapter";

/**
 * The docketPayments AfterCreateSuccess/AfterUpdateSuccess hook (which deducts
 * coupon/gift voucher balances) runs after the create/update response has already
 * been sent to the client. This polls the dependent record a few times so callers
 * that immediately refetch a coupon/gift voucher list don't read the pre-deduction
 * value. Best-effort: gives up silently after the attempt budget.
 */
export const waitForFieldChange = async (
  collection: string,
  id: string,
  field: string,
  previousValue: number,
  attempts = 5,
  delayMs = 300
): Promise<void> => {
  for (let i = 0; i < attempts; i++) {
    try {
      const record = await pb.collection(collection).getOne(id, { fields: `${field},id` });
      if (Number(record[field]) !== Number(previousValue)) return;
    } catch (e) {
      console.error(`Error polling ${collection}/${id} for ${field} change:`, e);
      return;
    }
    if (i < attempts - 1) await new Promise((resolve) => setTimeout(resolve, delayMs));
  }
};
